"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import {
  grey3,
  grey90,
  spacing32,
  white,
  whiteTransparency10,
  whiteTransparency20,
  whiteTransparency60,
  setAppearanceConstantLocal,
  textColorInverted
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";
import shared from "./shared";
const iconSpecificFontSize = "1.5rem";
const [buttonIconHoverDef, buttonIconHover] = setAppearanceConstantLocal(
  "button-icon-hover",
  {
    light: grey3,
    dark: whiteTransparency60,
    prefix: "eden"
  }
);
const [buttonIconActiveBackgroundDef, buttonIconActiveBackground] = setAppearanceConstantLocal("button-icon-active-background", {
  light: grey90,
  dark: whiteTransparency10,
  prefix: "eden"
});
const Component = styled.button`
  ${shared};
  ${buttonIconHoverDef};
  ${buttonIconActiveBackgroundDef};
  border: none;
  position: relative;
  &:before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  border-radius: 50%;
  ${({ size }) => size === "large" ? `min-width: 3.5rem;
            min-height: 3.5rem;` : size === "small" ? `min-width: ${spacing32};
              min-height: ${spacing32};` : `min-width: 2.5rem;
        min-height: 2.5rem;`};
  font-size: ${iconSpecificFontSize};
  padding: 0;
  background: transparent;
  color: currentcolor;

  @media (any-hover: hover) {
    &:hover {
      background: ${buttonIconHover};
      color: currentcolor;
    }
  }

  &:active,
  &[aria-pressed="true"] {
    background: ${buttonIconActiveBackground};
    color: ${textColorInverted};
  }

  &[disabled],
  &[disabled]:hover {
    background: transparent;
  }
  &:is(a):visited:not(:active) {
    color: currentcolor;
  }

  ${({ $overImage }) => $overImage ? `
     border: 1px solid ${white};
     background: ${whiteTransparency20};
     color: ${grey90};

     &:hover {
      background: ${whiteTransparency10};
      border: none;
      color: ${grey90};
     }

     &:active,
     &[aria-pressed="true"] {
       border: 1px solid ${whiteTransparency20};
       background: #00000099;
       color: ${whiteTransparency10};
     }
  ` : ""};
`;
const IconComponent = ({
  size = "normal",
  href,
  disabled,
  renderAs = href && !disabled ? "a" : "button",
  type = renderAs === "button" ? "button" : void 0,
  overImage,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  Component,
  {
    ...props,
    size,
    ref,
    type,
    href,
    disabled,
    as: renderAs,
    $overImage: overImage,
    children: props.children
  }
);
const Icon = forwardRef(IconComponent);
Icon.displayName = "Icon";
var Icon_default = Icon;
export {
  Icon_default as default
};
